module.exports = __webpack_public_path__ + "static/media/hufflepuff.d9272efa.png";